module.exports = __webpack_public_path__ + "img/report_img_202111.8c9d934c.jpg";